/**
 * Feature flag IDs – egy helyen, a VITE_FEATURE_MANAGEMENT JSON-ban használt id-k.
 * Itt használd ezeket a konstansokat, ne string literált.
 */
export const FEATURE_IDS = {
  KretaLogin: "KretaLogin",
  Register: "Register",
} as const;

export type FeatureId = (typeof FEATURE_IDS)[keyof typeof FEATURE_IDS];
